export default __webpack_public_path__ + "static/media/11.9fee8e99.jpeg";